import { createI18n } from 'vue-i18n'
import fr from './locales/fr'
import en from './locales/en'

// Waypoint360: minimal i18n layer for the DJI Pilot 2 webview. Backend-independent:
// the operator locale is read from the remote controller (see detectRemoteLocale).
// SN->organisation resolution (Lot B) will later override it with the account's
// preferred_lang via setLocale(). Cf. WAYPOINT360_DJI_MULTITENANT_CADRAGE.md §6.
export const SUPPORTED_LOCALES = ['fr', 'en'] as const
export type SupportedLocale = typeof SUPPORTED_LOCALES[number]
export const FALLBACK_LOCALE: SupportedLocale = 'fr'

function normalize (raw: string | null | undefined): SupportedLocale {
  const base = (raw || '').split('-')[0].toLowerCase()
  return (SUPPORTED_LOCALES as readonly string[]).includes(base)
    ? (base as SupportedLocale)
    : FALLBACK_LOCALE
}

// The webview runs inside the DJI Pilot 2 Android WebView, so navigator.language
// reflects the remote controller's system language — our locale source until the
// account's preferred_lang is known.
export function detectRemoteLocale (): SupportedLocale {
  return normalize(navigator.language)
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectRemoteLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  messages: { fr, en },
})

// Waypoint360: switch locale at runtime once the SN->org contract yields a
// preferred_lang (Lot B). Accepts any locale tag; unsupported ones fall back.
export function setLocale (locale: string | null | undefined) {
  const next = normalize(locale)
  ;(i18n.global.locale as unknown as { value: SupportedLocale }).value = next
  document.documentElement.setAttribute('lang', next)
}

document.documentElement.setAttribute('lang', detectRemoteLocale())

export default i18n
